(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[229],{

/***/ 23417:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/home",
      function () {
        return __webpack_require__(17786);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 52565:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ArticleList; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(80051);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(7583);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(82621);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(38194);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88349);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(48157);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(77162);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(52803);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33872);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34885);
/* harmony import */ var _utils_date__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60600);
/* harmony import */ var _ExternalLink__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91308);
/* harmony import */ var _HeadingText__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11498);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(8865);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(77005);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_icons_bi__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(8978);
/* harmony import */ var _MusicianAvatarName__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(88373);
/* harmony import */ var _MusicianPageLinker__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(45150);
















function ArticleList(_param) {
    var title = _param.title, _articles = _param.articles, articles = _articles === void 0 ? [] : _articles, _useToggle = _param.useToggle, useToggle = _useToggle === void 0 ? true : _useToggle, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_param, [
        "title",
        "articles",
        "useToggle"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(articles === null || articles === void 0 ? void 0 : articles.map(function(article) {
        return article.isRemoved;
    })), visibleInfo = ref[0], setVisibleInfo = ref[1];
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("article").t;
    if (!articles || (articles === null || articles === void 0 ? void 0 : articles.length) === 0) {
        return null;
    }
    var sortedArticles = (0,lodash_es__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(articles, "publishDate").reverse();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Box */ .xu, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({
        maxW: "1416px",
        marginTop: "16px"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_HeadingText__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                children: title ? title : t("articles")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .List */ .aV, {
                children: sortedArticles.map(function(article, i) {
                    var ref, ref1, ref2, ref3;
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .ListItem */ .HC, {
                        padding: "8px",
                        bgColor: "whiteAlpha.50",
                        marginBottom: "16px",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .HStack */ .Ug, {
                                padding: "4px",
                                cursor: "pointer",
                                _hover: {
                                    backgroundColor: "blackAlpha.800",
                                    transition: "background-color 0.2s ease-in-out"
                                },
                                onClick: function() {
                                    var nextVisibleInfo = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(visibleInfo);
                                    nextVisibleInfo[i] = !nextVisibleInfo[i];
                                    setVisibleInfo(nextVisibleInfo);
                                },
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Box */ .xu, {
                                        marginRight: "4px",
                                        w: "100px",
                                        children: (0,_utils_date__WEBPACK_IMPORTED_MODULE_3__/* .toSimpleDateFormat */ .gQ)(new Date(article.publishDate))
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Box */ .xu, {
                                        children: article.title
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ExternalLink__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                        href: article.link,
                                        padding: "8px",
                                        _hover: {
                                            backgroundColor: "blackAlpha.800",
                                            transition: "background-color 0.2s ease-in-out"
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_15__/* .Collapse */ .UO, {
                                in: visibleInfo[i],
                                animateOpacity: true,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Box */ .xu, {
                                    paddingLeft: "92px",
                                    marginTop: "16px",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .HStack */ .Ug, {
                                            children: [
                                                ((ref = article.lives) === null || ref === void 0 ? void 0 : ref.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Box */ .xu, {
                                                    fontWeight: "bold",
                                                    children: t("related-live")
                                                }),
                                                (ref1 = article.lives) === null || ref1 === void 0 ? void 0 : ref1.map(function(param) {
                                                    var id = param.id, title = param.title;
                                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Box */ .xu, {
                                                        marginRight: "4px",
                                                        padding: "16px",
                                                        _hover: {
                                                            backgroundColor: "blackAlpha.800",
                                                            transition: "background-color 0.2s ease-in-out"
                                                        },
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_6___default()), {
                                                            href: "/live/".concat(id),
                                                            children: title
                                                        })
                                                    }, id);
                                                })
                                            ]
                                        }),
                                        ((ref2 = article.musicians) === null || ref2 === void 0 ? void 0 : ref2.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Box */ .xu, {
                                            fontWeight: "bold",
                                            children: t("related-musician")
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Box */ .xu, {
                                            marginTop: "8px",
                                            marginBottom: "8px",
                                            display: "flex",
                                            flexWrap: "wrap",
                                            children: (ref3 = article.musicians) === null || ref3 === void 0 ? void 0 : ref3.map(function(param) {
                                                var id = param.id, useSlug = param.useSlug, slug = param.slug, name = param.name, profileImage = param.profileImage;
                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_MusicianPageLinker__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                                    useSlug: useSlug,
                                                    slug: slug,
                                                    id: id,
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Box */ .xu, {
                                                        as: "a",
                                                        padding: "8px",
                                                        _hover: {
                                                            backgroundColor: "blackAlpha.800",
                                                            transition: "background-color 0.2s ease-in-out"
                                                        },
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_MusicianAvatarName__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                                            name: name,
                                                            profileImage: profileImage
                                                        })
                                                    })
                                                }, "article-musician-".concat(id));
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ExternalLink__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                            href: article.link,
                                            hideIcon: true,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_16__/* .Button */ .zx, {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_bi__WEBPACK_IMPORTED_MODULE_17__/* .BiLinkExternal */ .rpH, {
                                                        size: "22px"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Box */ .xu, {
                                                        display: "inline-block",
                                                        marginLeft: "8px",
                                                        children: t("read-more")
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }, "article-".concat(i));
                })
            })
        ]
    }));
};


/***/ }),

/***/ 54911:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70477);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46945);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93597);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34885);




var ErrorBoundary = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(ErrorBoundary, Component);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(ErrorBoundary);
    function ErrorBoundary() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, ErrorBoundary);
        return _super.apply(this, arguments);
    }
    var _proto = ErrorBoundary.prototype;
    _proto.componentDidCatch = function componentDidCatch(error, errorInfo) {
        console.log(error, errorInfo);
    /*Sentry.withScope(scope => {
      scope.setExtra('errorMessage', errorInfo)
      Sentry.captureException(error)
    })*/ };
    _proto.render = function render() {
        return this.props.children;
    };
    return ErrorBoundary;
}(react__WEBPACK_IMPORTED_MODULE_0__.Component);
/* harmony default export */ __webpack_exports__["Z"] = (ErrorBoundary);


/***/ }),

/***/ 91308:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ExternalLink; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(80051);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7583);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82621);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88349);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48157);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34885);
/* harmony import */ var react_icons_bi__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8978);







function ExternalLink(_param) {
    var href = _param.href, _hideIcon = _param.hideIcon, hideIcon = _hideIcon === void 0 ? false : _hideIcon, children = _param.children, restProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "href",
        "hideIcon",
        "children"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        as: "a",
        href: href,
        target: "_blank",
        wordBreak: "break-all",
        rel: "noopener noreferrer"
    }, restProps), {
        children: [
            hideIcon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
                w: "100%",
                children: children
            }),
            !hideIcon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .HStack */ .Ug, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .xv, {
                        children: children
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_bi__WEBPACK_IMPORTED_MODULE_6__/* .BiLinkExternal */ .rpH, {
                            size: "22px"
                        })
                    })
                ]
            })
        ]
    }));
};


/***/ }),

/***/ 69864:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ HoverBox; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(80051);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7583);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82621);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88349);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48157);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34885);






function HoverBox(_param) {
    var children = _param.children, restProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        padding: "8px",
        _hover: {
            cursor: "pointer",
            bgColor: "blackAlpha.500"
        }
    }, restProps), {
        children: children
    }));
};


/***/ }),

/***/ 31842:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ LiveBadge; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(80051);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7583);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82621);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88349);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48157);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34885);






function LiveBadge(_param) {
    var position = _param.position, children = _param.children, restProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "position",
        "children"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        position: "absolute",
        bgColor: "gray.700",
        borderRadius: "8px",
        padding: [
            "8px",
            null,
            null,
            "16px"
        ],
        fontSize: [
            "xs",
            null,
            "md",
            "lg"
        ]
    }, restProps), {
        children: children
    }));
};


/***/ }),

/***/ 89251:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ LivePoster; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88349);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(48157);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34885);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83136);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95502);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(33872);
/* harmony import */ var _utils_poster__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(20692);







function LivePoster(param) {
    var _defaultImageUrl = param.defaultImageUrl, defaultImageUrl = _defaultImageUrl === void 0 ? "/images/bg_music_live_stage.jpg" : _defaultImageUrl, livePoster = param.livePoster, _useImageLazyLoad = param.useImageLazyLoad, useImageLazyLoad = _useImageLazyLoad === void 0 ? false : _useImageLazyLoad;
    var ref, ref1;
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("live").t;
    var livePosterImage = (ref1 = (0,_utils_image__WEBPACK_IMPORTED_MODULE_3__/* .findImage */ .jw)((ref = livePoster.posters[0]) === null || ref === void 0 ? void 0 : ref.formats)) === null || ref1 === void 0 ? void 0 : ref1.url;
    var imageUrl = livePosterImage ? (0,_utils_image__WEBPACK_IMPORTED_MODULE_3__/* .getMediaPath */ .Nf)(livePosterImage) : defaultImageUrl;
    var alt = t("altText", {
        title: livePoster.title
    });
    var isVideoPoster = livePoster.posters.length > 0 && (0,_utils_poster__WEBPACK_IMPORTED_MODULE_5__/* .isVideo */ .Wv)(livePoster.posters[0]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Box */ .xu, {
        position: "relative",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .AspectRatio */ .oM, {
                ratio: 3 / 4,
                bgColor: "#000",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        isVideoPoster && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Box */ .xu, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("video", {
                                src: (0,_utils_image__WEBPACK_IMPORTED_MODULE_3__/* .getMediaPath */ .Nf)(livePoster.posters[0].url),
                                muted: true,
                                autoPlay: true,
                                loop: true,
                                playsInline: true
                            })
                        }),
                        !isVideoPoster && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                            src: imageUrl,
                            objectFit: "contain",
                            layout: "fill",
                            alt: alt,
                            priority: !useImageLazyLoad
                        })
                    ]
                })
            }),
            livePoster.isCanceled && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Box */ .xu, {
                        position: "absolute",
                        top: "0",
                        left: "0",
                        right: "0",
                        bottom: "0",
                        zIndex: "3",
                        backgroundColor: "rgba(255, 255, 255, 0.7)"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Box */ .xu, {
                        position: "absolute",
                        left: "50%",
                        top: "50%",
                        transform: "translate(-50%, -50%)",
                        backgroundColor: "gray.600",
                        padding: [
                            "16px",
                            "24px"
                        ],
                        borderRadius: "16px",
                        zIndex: "4",
                        fontSize: [
                            "sm",
                            "md",
                            "xl"
                        ],
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Text */ .xv, {
                            children: "CANCELED"
                        })
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 88373:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MusicianAvatarName; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(80051);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7583);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82621);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88349);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48157);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(20390);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34885);
/* harmony import */ var _utils_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95502);







function MusicianAvatarName(_param) {
    var name = _param.name, profileImage = _param.profileImage, restProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "name",
        "profileImage"
    ]);
    var ref;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .HStack */ .Ug, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, restProps), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Avatar */ .qE, {
                name: name,
                src: (ref = (0,_utils_image__WEBPACK_IMPORTED_MODULE_2__/* .formatsToUrl */ .U4)(profileImage === null || profileImage === void 0 ? void 0 : profileImage.formats)) !== null && ref !== void 0 ? ref : "/images/animal_music_band.png"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .xv, {
                children: name
            })
        ]
    }));
};


/***/ }),

/***/ 17786:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ HomePage; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(88349);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(34885);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(77005);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(83136);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ../../node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(33872);
// EXTERNAL MODULE: ../../node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__(48157);
// EXTERNAL MODULE: ../../node_modules/@chakra-ui/skeleton/dist/index.esm.js
var dist_index_esm = __webpack_require__(60925);
// EXTERNAL MODULE: ../../node_modules/lodash-es/isNil.js
var isNil = __webpack_require__(10143);
// EXTERNAL MODULE: ../../node_modules/lodash-es/head.js
var head = __webpack_require__(84757);
// EXTERNAL MODULE: ../web-queries/src/types/generated.tsx + 19 modules
var generated = __webpack_require__(48600);
// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(11225);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./components/Meta.tsx
var Meta = __webpack_require__(49330);
// EXTERNAL MODULE: ./components/PageContent.tsx + 2 modules
var PageContent = __webpack_require__(69856);
// EXTERNAL MODULE: ./components/HeadingText.tsx
var HeadingText = __webpack_require__(11498);
// EXTERNAL MODULE: ./components/ErrorBoundary.tsx
var ErrorBoundary = __webpack_require__(54911);
// EXTERNAL MODULE: ./components/HoverBox.tsx
var HoverBox = __webpack_require__(69864);
// EXTERNAL MODULE: ./utils/image.ts
var utils_image = __webpack_require__(95502);
// EXTERNAL MODULE: ./utils/date.ts
var date = __webpack_require__(60600);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(80051);
// EXTERNAL MODULE: ../../node_modules/lodash-es/flatMap.js + 1 modules
var flatMap = __webpack_require__(64154);
// EXTERNAL MODULE: ../../node_modules/lodash-es/isEmpty.js
var isEmpty = __webpack_require__(38879);
// EXTERNAL MODULE: ./components/LivePoster.tsx
var LivePoster = __webpack_require__(89251);
// EXTERNAL MODULE: ../../node_modules/react-icons/ti/index.esm.js
var ti_index_esm = __webpack_require__(56280);
// EXTERNAL MODULE: ./components/LiveBadge.tsx
var LiveBadge = __webpack_require__(31842);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(53746);
// EXTERNAL MODULE: ./components/MusicianTag.tsx
var MusicianTag = __webpack_require__(94913);
// EXTERNAL MODULE: ./utils/link.ts
var utils_link = __webpack_require__(54571);
;// CONCATENATED MODULE: ./components/FestivalItem.tsx














function FestivalItem(param) {
    var live = param.live;
    var ref;
    var t = (0,useTranslation/* default */.Z)("live").t;
    var locale = (0,router.useRouter)().locale;
    var url = "/live/".concat(live.id);
    var ddayText = (0,date/* getDateDistance */.xT)(live.startDate);
    var startDate = (0,date/* dateToString */.UW)(new Date(live.startDate), locale);
    var endDate = (0,date/* dateToString */.UW)(new Date(live.endDate), locale);
    var ref1;
    var lineup = live.festival ? (0,flatMap/* default */.Z)(live.festival.festivalItems.map(function(festivalItem) {
        return festivalItem.festivalItemTimeTables.map(function(timetable) {
            var ref;
            return {
                id: timetable.id,
                name: (ref1 = (ref = timetable.musician) === null || ref === void 0 ? void 0 : ref.name) !== null && ref1 !== void 0 ? ref1 : "",
                useSlug: false,
                slug: ""
            };
        });
    })) : live.musicians.map(function(musician) {
        return {
            id: musician.id,
            name: musician.name,
            useSlug: musician.useSlug,
            slug: musician.slug
        };
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
        position: "relative",
        paddingBottom: 10,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: url,
                passHref: true,
                prefetch: false,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                    as: "a",
                    display: "block",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LivePoster/* default */.Z, {
                            livePoster: live
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                            mt: 4,
                            position: "relative",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                    fontSize: "1.2rem",
                                    fontWeight: "bold",
                                    marginBottom: "4px",
                                    children: live.isCanceled ? "[".concat(t("canceled"), "] ").concat(live.title) : live.title
                                }),
                                live.stage && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: (0,utils_link/* generateStageLink */.Eq)(live.stage),
                                    prefetch: false,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Text */.xv, {
                                        children: [
                                            "장소: ",
                                            (ref = live.stage) === null || ref === void 0 ? void 0 : ref.name
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                    children: t("festival-date", {
                                        startDate: startDate,
                                        endDate: endDate
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Stack */.Kq, {
                direction: "row",
                wrap: "wrap",
                marginTop: "8px",
                children: lineup.filter(function(lineup) {
                    return lineup.name;
                }).map(function(musician) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MusicianTag/* default */.Z, (0,_object_spread/* default */.Z)({}, musician), "musician-".concat(musician.id));
                })
            }),
            live.liveStreaming && /*#__PURE__*/ (0,jsx_runtime.jsx)(LiveBadge/* default */.Z, {
                top: "12px",
                left: "12px",
                bgColor: "red.700",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ti_index_esm/* TiMediaRecord */.txJ, {
                            size: 20
                        }),
                        " Streaming"
                    ]
                })
            }),
            !(0,isEmpty/* default */.Z)(ddayText) && /*#__PURE__*/ (0,jsx_runtime.jsx)(LiveBadge/* default */.Z, {
                top: "12px",
                right: "12px",
                children: ddayText
            })
        ]
    });
};

// EXTERNAL MODULE: ../../node_modules/react-big-calendar/dist/react-big-calendar.esm.js
var react_big_calendar_esm = __webpack_require__(18700);
// EXTERNAL MODULE: ../../node_modules/moment/moment.js
var moment = __webpack_require__(21160);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ../../node_modules/moment/locale/ko.js
var ko = __webpack_require__(41699);
;// CONCATENATED MODULE: ./components/LiveCalendar.tsx






var localizer = (0,react_big_calendar_esm/* momentLocalizer */.Zt)((moment_default())) // or globalizeLocalizer
;
var LiveEventModal = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2421).then(__webpack_require__.bind(__webpack_require__, 22421));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(22421)
            ];
        }
    },
    ssr: false
});
var ColoredDateCellWrapper = function(param) {
    var children = param.children;
    return /*#__PURE__*/ react.cloneElement(react.Children.only(children), {
        style: {
            backgroundColor: "black"
        }
    });
};
function LiveCalendar(param) {
    var liveEvents = param.liveEvents, date = param.date, onNavigate = param.onNavigate;
    var ref = (0,react.useState)(null), selectedLiveEvent = ref[0], setSelectedLiveEvent = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            selectedLiveEvent && /*#__PURE__*/ (0,jsx_runtime.jsx)(LiveEventModal, {
                liveEvent: selectedLiveEvent,
                onClose: function() {
                    return setSelectedLiveEvent(null);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_big_calendar_esm/* Calendar */.f, {
                events: liveEvents,
                step: 30,
                defaultDate: date,
                components: {
                    timeSlotWrapper: ColoredDateCellWrapper
                },
                localizer: localizer,
                onSelectEvent: function(event) {
                    setSelectedLiveEvent(event);
                },
                onNavigate: onNavigate
            })
        ]
    });
};

;// CONCATENATED MODULE: ./utils/calendar.ts

var liveListToEvents = function(liveList) {
    var ref;
    return (ref = liveList.map(function(live) {
        var ref, ref1;
        var livePosterImage = (ref1 = (0,utils_image/* findImage */.jw)((ref = live.posters[0]) === null || ref === void 0 ? void 0 : ref.formats)) === null || ref1 === void 0 ? void 0 : ref1.url;
        var poster = livePosterImage ? (0,utils_image/* getMediaPath */.Nf)(livePosterImage) : "/images/bg_music_live_stage.jpg";
        var _endDate;
        return {
            id: live.id,
            title: live.title,
            musicians: live.musicians,
            poster: poster,
            start: new Date(live.startDate),
            end: new Date((_endDate = live.endDate) !== null && _endDate !== void 0 ? _endDate : live.startDate),
            allDay: false
        };
    })) !== null && ref !== void 0 ? ref : [];
};

;// CONCATENATED MODULE: ./components/LiveCalendarView.tsx







function LiveCalendarView(param) {
    var visibleDate = param.visibleDate, lives = param.lives, onDateChange = param.onDateChange;
    var t = (0,useTranslation/* default */.Z)("live").t;
    if (!lives) {
        return null;
    }
    var events = liveListToEvents(lives);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadingText/* default */.Z, {
                    children: t("live-calendar")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(LiveCalendar, {
                    liveEvents: events,
                    date: visibleDate,
                    onNavigate: onDateChange
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./components/ArticleList.tsx
var ArticleList = __webpack_require__(52565);
;// CONCATENATED MODULE: ./pages/home.tsx
// @ts-ignore

// @ts-ignore
// import * as Sentry from '@sentry/browser'


















var DynamicHomeLiveList = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9037).then(__webpack_require__.bind(__webpack_require__, 29037));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(29037)
            ];
        }
    },
    suspense: true
});
var __N_SSG = true;
function HomePage(param) {
    var todayStartString = param.todayStartString, todayEndString = param.todayEndString, monthStartDateString = param.monthStartDateString, monthEndDateString = param.monthEndDateString;
    var t = (0,useTranslation/* default */.Z)("homePage").t;
    var ref = (0,react.useState)(new Date(monthStartDateString)), visibleDate = ref[0], setVisibleDate = ref[1];
    var ref1 = (0,generated/* useHomeLiveContentsQuery */.itG)({
        variables: {
            limit: 48,
            todayStart: todayStartString,
            todayEnd: todayEndString
        }
    }), data = ref1.data, homeDataLoading = ref1.loading, error = ref1.error;
    var ref2 = (0,generated/* useLiveEventListQuery */.AUg)({
        variables: {
            monthStartDateString: monthStartDateString,
            monthEndDateString: monthEndDateString
        }
    }), liveEventList = ref2.data, liveEventLoading = ref2.loading, refetch = ref2.refetch;
    var ref3 = (0,generated/* useHomeContentsQuery */.DsV)({
        variables: {
            limit: 12
        }
    }), homeContentData = ref3.data, homeContentLoading = ref3.loading;
    var ref4;
    var upcomingLives = (ref4 = data === null || data === void 0 ? void 0 : data.upcomingLives) !== null && ref4 !== void 0 ? ref4 : null;
    var ref5;
    var todayLives = (ref5 = data === null || data === void 0 ? void 0 : data.todayLives) !== null && ref5 !== void 0 ? ref5 : null;
    var ref6;
    var recentlyArticles = (ref6 = homeContentData === null || homeContentData === void 0 ? void 0 : homeContentData.recentlyArticles) !== null && ref6 !== void 0 ? ref6 : null;
    var ref7;
    var recentlyReleasedAlbums = (ref7 = homeContentData === null || homeContentData === void 0 ? void 0 : homeContentData.recentlyReleasedAlbums) !== null && ref7 !== void 0 ? ref7 : null;
    var ref8;
    var currentFestivals = (ref8 = data === null || data === void 0 ? void 0 : data.currentFestivals) !== null && ref8 !== void 0 ? ref8 : null;
    var ref9;
    var monthlyLives = (ref9 = liveEventList === null || liveEventList === void 0 ? void 0 : liveEventList.lives) !== null && ref9 !== void 0 ? ref9 : null;
    if (error) {
        // Sentry.captureException(error)
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
            w: "100%",
            textAlign: "center",
            position: "fixed",
            left: "50%",
            top: "50%",
            transform: "translate(-50%, -50%)",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                fontSize: "30px",
                dangerouslySetInnerHTML: {
                    __html: t("common:something-wrong")
                }
            })
        });
    }
    var ref10;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ErrorBoundary/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta/* default */.Z, {
                title: t("title"),
                description: t("description"),
                uri: "/",
                keywords: t("keywords")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageContent/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Heading */.X6, {
                        as: "h1",
                        className: "screen-reader-only",
                        children: [
                            t("title"),
                            " - ",
                            t("description")
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                        position: "relative",
                        marginTop: "24px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                marginBottom: "24px",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Skeleton */.Od, {
                                    isLoaded: !liveEventLoading && !(0,isNil/* default */.Z)(monthlyLives),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LiveCalendarView, {
                                        visibleDate: visibleDate,
                                        lives: monthlyLives,
                                        onDateChange: function(changedDate) {
                                            setVisibleDate(changedDate);
                                            var monthDateStrings = (0,date/* getCurrentMonthRange */.L5)(changedDate);
                                            refetch(monthDateStrings);
                                        }
                                    })
                                })
                            }),
                            currentFestivals && currentFestivals.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadingText/* default */.Z, {
                                        children: t("common:current-festival")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* SimpleGrid */.MI, {
                                        columns: [
                                            1,
                                            1,
                                            2,
                                            2,
                                            3
                                        ],
                                        gap: "16px",
                                        children: currentFestivals === null || currentFestivals === void 0 ? void 0 : currentFestivals.flatMap(function(festival) {
                                            return (0,isNil/* default */.Z)(festival) ? [] : [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HoverBox/* default */.Z, {
                                                    position: "relative",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FestivalItem, {
                                                        live: festival
                                                    })
                                                }, "festival-".concat(festival.id)), 
                                            ];
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Skeleton */.Od, {
                                isLoaded: !homeDataLoading,
                                minH: "300px",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicHomeLiveList, {
                                    lives: todayLives,
                                    title: t("today-live"),
                                    emptyText: t("today-live-not-found")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Skeleton */.Od, {
                                isLoaded: !homeDataLoading,
                                minH: "300px",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicHomeLiveList, {
                                    lives: upcomingLives,
                                    title: t("upcoming-live"),
                                    emptyText: t("upcoming-live-not-found")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Skeleton */.Od, {
                                isLoaded: !homeContentLoading && !(0,isNil/* default */.Z)(recentlyArticles),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleList/* default */.Z, {
                                        articles: recentlyArticles,
                                        title: t("article:music-related-articles")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadingText/* default */.Z, {
                                                children: t("latest-released-album")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* SimpleGrid */.MI, {
                                                flexDirection: "column",
                                                columns: [
                                                    1,
                                                    2,
                                                    3,
                                                    4
                                                ],
                                                gap: "16px",
                                                children: recentlyReleasedAlbums === null || recentlyReleasedAlbums === void 0 ? void 0 : recentlyReleasedAlbums.flatMap(function(album) {
                                                    var ref, ref1;
                                                    return (0,isNil/* default */.Z)(album) ? [] : [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HoverBox/* default */.Z, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                href: "/albums/".concat(album.id),
                                                                passHref: true,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                                                                    as: "a",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* AspectRatio */.oM, {
                                                                            ratio: 1,
                                                                            position: "relative",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                                src: "".concat((ref10 = (0,utils_image/* formatsToUrl */.U4)((ref = (0,head/* default */.Z)(album.images)) === null || ref === void 0 ? void 0 : ref.formats)) !== null && ref10 !== void 0 ? ref10 : "/images/music_record_disc.png"),
                                                                                objectFit: "contain",
                                                                                layout: "fill",
                                                                                alt: "앨범 음원 ".concat(album.name, "의 커버")
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                                                            padding: "8px",
                                                                            bgColor: "whiteAlpha.300",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Text */.xv, {
                                                                                children: [
                                                                                    (ref1 = album.musician) === null || ref1 === void 0 ? void 0 : ref1.name,
                                                                                    " - ",
                                                                                    album.name
                                                                                ]
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        }, "recently-added-album-".concat(album.id)), 
                                                    ];
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
 // @ts-ignore


/***/ }),

/***/ 54571:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Eq": function() { return /* binding */ generateStageLink; },
/* harmony export */   "aM": function() { return /* binding */ generateMusicianLink; }
/* harmony export */ });
/* unused harmony export generateLink */
/* harmony import */ var common_utils_regex__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44777);

var generateStageLink = function(stage) {
    return generateLink(stage, "stages", "venues");
};
var generateMusicianLink = function(musician) {
    return generateLink(musician, "musicians", "artists");
};
var generateLink = function(linkable, defaultPath, slugPath) {
    return linkable.useSlug && common_utils_regex__WEBPACK_IMPORTED_MODULE_0__/* .SLUG_REGEX.test */ .Zs.test(linkable.slug) ? "/".concat(slugPath, "/").concat(linkable.slug) : "/".concat(defaultPath, "/").concat(linkable.id);
};


/***/ }),

/***/ 44777:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "JQ": function() { return /* binding */ KAKAO_PLACE_LINK_REGEX; },
/* harmony export */   "Tu": function() { return /* binding */ INSTAGRAM_ID_REGEX_ALL; },
/* harmony export */   "Xg": function() { return /* binding */ SLUG_REGEX_BY_CHATGPT; },
/* harmony export */   "Zs": function() { return /* binding */ SLUG_REGEX; },
/* harmony export */   "j0": function() { return /* binding */ IS_HTTP_LINK_REGEX; },
/* harmony export */   "o": function() { return /* binding */ IS_COLOR_CODE_REGEX; },
/* harmony export */   "w8": function() { return /* binding */ HASHTAG_REGEX; }
/* harmony export */ });
/* unused harmony export INSTAGRAM_ID_REGEX */
var IS_HTTP_LINK_REGEX = /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)$/;
var IS_COLOR_CODE_REGEX = /^#(?:[0-9a-fA-F]{3}){1,2}$/;
var HASHTAG_REGEX = /#([ㄱ-ㅎ|ㅏ-ㅣ|가-힣|a-z|A-Z|0-9|\-_]+)/g;
var INSTAGRAM_ID_REGEX = /@([0-9|a-z|A-Z\d-_.]+)/;
var INSTAGRAM_ID_REGEX_ALL = /@([0-9|a-z|A-Z\d-_.]+)/g;
var SLUG_REGEX = /^[a-z0-9_.-]{1,30}$/;
var KAKAO_PLACE_LINK_REGEX = /https:\/\/place\.map\.kakao\.com\/[0-9]+$/;
var SLUG_REGEX_BY_CHATGPT = /^[a-zA-Z0-9]+(?:[_\-\.][a-zA-Z0-9]+)*$/;


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4847,4424,6525,5789,8917,2123,4285,2445,8461,3845,6991,3661,4887,2748,1274,1222,7177,3136,9146,390,7833,8248,7795,4526,9774,2888,179], function() { return __webpack_exec__(23417); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);